module.exports = __webpack_public_path__ + "img/sales-inventory-dashboard-banner.ad5f6519.png";